export default __webpack_public_path__ + "opus-decoderWorker.min.f69d392.js";